<div class="newsletter-banner">
  <label>Join the newsletter</label>
  <span>Recieve fresh content straight to your inbox, <br />but not in an annoying way!</span>
  <form #nlBanner="ngForm" [attr.data-content]="'Blog Newsletter Banner Submit'" (ngSubmit)="subscribe($event)">
    <input type="email" email name="email" placeholder="you@example.com" [(ngModel)]="email" required />
    <button class="primary" type="submit" [disabled]="nlBanner.invalid">Subscribe</button>
  </form>
</div>
<div 
	*ngIf="submitState || successState || failureState" 
	[@submitState]="submitState || successState || failureState" 
	class="nb-success"
>
	<div class="nbs-main">
		<a class="nbs-close" href="#" (click)="closeConf($event); false;"><img src="../../../../assets/images/close-gold-001.svg" width="40" alt="Newesletter Banner Confirmation Close"></a>
		<div class="clearfix"></div>
		<p class="nbs-message" [innerHTML]="getSubmitMsg()"></p>
	</div>
</div>
